import { delay } from "../common/functions";
import { $, variables } from "../common/variables";

// function qui créé le statut actif des markers
export const markeractiveState = (selectedItem, markerArray, markersCluster) => {
  if (selectedItem) {
    // Selection du marker correspondant à l'item de la liste selectionné
    const shopID = selectedItem.dataset.shop
    const markers = markerArray
    const activeMarkers = markers.filter(marker => marker.options.shopId === shopID)
    // console.log(activeMarkers)

    if (activeMarkers.length) {
      activeMarkers.forEach(async (activeMarker) => {
        // Petit wait poour attendre que la carte se rende compte de ce qui lui arrive
        await delay(500)

        // exception au changement de selection du commerce de la liste
        const markerIcon = activeMarker._icon;
        // console.log(activeMarker)
        if (markerIcon !== null && markerIcon !== undefined) {
          // Si le marker est seul
          const markers = document.querySelectorAll(".leaflet-marker-icon")
          if (markers.length) {
            markers.forEach(marker => {
              marker.classList.remove("selected")
            })
          }
          markerIcon.classList.add("selected")
        } else {
          // Si le marker est dans un cluster
          const parentElement = markersCluster.getVisibleParent(activeMarker)
          if (parentElement) {
            const allClusters = document.querySelectorAll(".leaflet-marker-icon.cluster")
            if (allClusters.length) {
              allClusters.forEach(cluster => {
                cluster.classList.remove("selected")
              })
            }
            parentElement._icon.classList.add("selected")
          }
        }
      })

      return activeMarkers[0]
    }
  }
}

// met un statut actif sur le marker au click du cluster au max zoom
export const markerClusterSpiderify = (markerArray, markersCluster) => {
  markersCluster.on("spiderfied", function (event) {
    const selectedItem = document.querySelector(".container__item.selected");
    markeractiveState(selectedItem, markerArray, markersCluster);
  });
};

export const markerEvent = (map, markerArray, markersCluster, offset) => {
  markersCluster.on('click', (e) => {
    // Fit de la map
    const markerPosition = map.latLngToContainerPoint(e.latlng);
    const newPosition = L.point([
      markerPosition.x - offset,
      markerPosition.y
    ]);
    const newLatLng = map.containerPointToLatLng(newPosition);

    if (variables.shortcodeTemplateValue === "onlymap") {
      map.setView(e.latlng, map.getZoom());
    } else if (variables.shortcodeTemplateValue === "full") {
      map.setView(newLatLng, map.getZoom(), {
        animate: true
      });
    }

    // Récupération de l'id du magasin
    const shopId = e.layer.options.shopId;

    // Gestion de l'actif dans la liste de magasins
    const items = document.querySelectorAll('.container__item')
    if (items.length) {
      items.forEach(item => {
        item.classList.remove('selected')
      })
    }
    const item = document.querySelector(`.container__item[data-shop="${shopId}"]`)
    if (item) {
      item.classList.add('selected')

      item.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start"
      })

      // Open de la fancybox du magasin
      $.fancybox.destroy();
      $.fancybox.open({
        src: `?id=${shopId}&format=popup`,
        type: "ajax",
        opts: {
          parentEl: "#storeSingle",
          touch: false,
          animationEffect: "fade",
          spinnerTpl: "",
          beforeClose: function () {
            item.classList.remove("selected");
            let markers = document.getElementsByClassName("leaflet-marker-icon");
            for (let j = 0; j < markers.length; j++) {
              markers[j].classList.remove("selected");
            }
          },
          afterLoad: function (instance, current) {
            if ($(window).width() > 768) {
              setTimeout(() => {
                $("#overlayScrollbar").overlayScrollbars({
                  scrollbars: {
                    autoHide: "leave",
                    autoHideDelay: 400
                  }
                });
              }, 100);
            }
            $(
              ".venteFlash__counter-countdown .countdown"
            ).each(function () {
              flashSaleCountdown(this);
            });
          }
        }
      });
    }

    // Gestion de l'actif sur les markers
    markeractiveState(item, markerArray, markersCluster)
  });
};

// met uns tatut actif sur les markers/cluster au zoom
export const zoomend = (map, markerArray, markersCluster) => {
  map.on("zoomend", () => {
    const selectedItem = document.querySelector(".container__item.selected");
    markeractiveState(selectedItem, markerArray, markersCluster);
  });
};
